import { createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c47f397")

_pushScopeId("data-v-6c47f397")
const _hoisted_1 = { class: "drop-down-frame" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#menu" }, [
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
        class: "drop-down-backdrop"
      }),
      _createVNode(_Transition, {
        name: "custom-classes-transition",
        duration: 100,
        "enter-active-class": "animated fadeIn",
        "leave-active-class": "animated fadeOut"
      }, {
        default: _withId(() => [
          _withDirectives(_createVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 512), [
            [_vShow, _ctx.show]
          ])
        ]),
        _: 3
      })
    ], 512), [
      [_vShow, _ctx.show]
    ])
  ]))
})